import type { ReactNode } from 'react';
import { SelectorPagingControls } from '../picker/SelectorPagingControls';

export interface SelectorPickModalFooterProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  actions: ReactNode;
}

export function SelectorPickModalFooter({
  currentPage,
  totalPages,
  pageSize,
  onPageChange,
  onPageSizeChange,
  actions,
}: SelectorPickModalFooterProps) {
  return (
    <div
      className="gap-phx-4 grid w-full grid-cols-1 items-center md:grid-cols-[1fr_auto_1fr]"
      data-testid="selector-pick-modal-footer"
    >
      <SelectorPagingControls
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={pageSize}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        paginationVariant="plain"
        layout="modalGrid"
      />
      <div className="gap-phx-3 flex items-center justify-self-end">{actions}</div>
    </div>
  );
}
